export function getRegionOrgId(value: string): string {
    const prefix = value.slice(0, value.lastIndexOf("-"));
    return `${prefix}-1`;
}

export function isCountryOrgId(value: string): boolean {
    return value === "ORG-Sverige-0";
}
